// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1SCV4","boxTitle":"Qualiphy_boxTitle__20SUe","box":"Qualiphy_box__3jXFg","toggleWrap":"Qualiphy_toggleWrap__1rHtg"};